





































import { Vue, Component } from 'vue-property-decorator';
import { List, Sticky } from 'vant';
import { getRank } from '../api';

Vue.use(Sticky);
Vue.use(List);
@Component
export default class Rank extends Vue {
  loading = false;
  finished = false;
  page = 1;
  getListData: any[] = [];
  dataPic = '';
  // 初使加载
  async onLoad() {
    this.loading = true;

    const res = await getRank(this.page);
    this.dataPic = res.data.top.county;
    this.fetchListData(res);
  }
  fetchListData(res: any) {
    if (res.status === 1 || res.code === 500 || res.msg === '暂无数据') {
      this.finished = true;
    } else {
      this.getListData = res.data.list2;
      this.page = this.page + 1;
      this.finished = false;
    }
    this.loading = false;
    this.finished = true;
  }
}
